module.exports = __webpack_public_path__ + "img/hospitalGreen.30cdb584.svg";